module.exports = __webpack_public_path__ + "473f3e6011f1e311b178c41490323c4c.jpg";